var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClearFilter = function SvgClearFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M25 4 5 24l1.414 1.414L15.828 16H21v-2h-3.172l3-3H24V9h-1.172l3.586-3.586zM6 11h10l2-2H6zm5 5 2-2H9v2zm2 5h4v-2h-4z",
    clipRule: "evenodd"
  })));
};
export default SvgClearFilter;